module.exports = __webpack_public_path__ + "static/media/youtube (1).8536d262.svg";